// extracted by mini-css-extract-plugin
export default {"root":"Badge__root--kPMTGu","verified":"Badge__verified--b1lIvG","disabled":"Badge__disabled--eMlw+X"};